// just add the following to an element and include the mixi
//    class="sticky hidding-toolbar glassy-toolbar"
//    :class="{ 'hidding-toolbar--hidden': !showNavbar }"


export const hiddingOnScroll = {
  data() {
    return {
      showNavbar: true,
      lastScrollPosition: 0,
      ticking: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      if (!this.ticking) {
        let that = this
        window.requestAnimationFrame(function() {
          that.setNavbarVisibility();
          that.ticking = false;
        });

        this.ticking = true;
      }
    },
    setNavbarVisibility () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition

      if (this.showNavbar) {
        document.body.classList.add("show-navbar")
      } else {
        if (document.getElementsByClassName("navbar-menu is-active").length == 0) {
          document.body.classList.remove("show-navbar")
        }
      }
    }
  }
}
